import { useState, type FormEvent } from 'react'
import { ApiError } from '@/lib/api'
import type { StudentContractInfo } from '@/types/api'
import { cpfDigits, isValidCpf, needsCpf } from './studentContract'
import { useIssueStudentContract } from './useStudentContract'

export const CONTRACT_GENERIC_ERROR = 'Não foi possível gerar o contrato agora. Tente novamente em alguns minutos.'

export interface ContractIssueForm {
  cpf: string
  setCpf: (value: string) => void
  askCpf: boolean
  error: string | null
  setError: (value: string | null) => void
  isPending: boolean
  submit: (event: FormEvent) => void
}

/**
 * Estado do "Gerar contrato" (faixa do app e passo do onboarding): pede o CPF so quando a
 * API pediu (MH13-01: o RG saiu), valida antes de chamar e traduz o erro. `enabled` = a tela esta no estado de gerar.
 */
export function useContractIssueForm(info: StudentContractInfo | undefined, enabled: boolean): ContractIssueForm {
  const issue = useIssueStudentContract()
  const [cpf, setCpf] = useState('')
  const [error, setError] = useState<string | null>(null)

  const askCpf = enabled && needsCpf(info)

  const submit = (event: FormEvent) => {
    event.preventDefault()
    setError(null)
    if (askCpf && !isValidCpf(cpf)) {
      setError('Informe um CPF válido.')
      return
    }
    const data = { cpf: askCpf ? cpfDigits(cpf) : undefined }
    issue.mutate(data, {
      onError: (err) => setError(err instanceof ApiError && err.status < 500 ? err.message : CONTRACT_GENERIC_ERROR),
    })
  }

  return { cpf, setCpf, askCpf, error, setError, isPending: issue.isPending, submit }
}
